export { default as CookieBanner } from './CookieBanner';
